// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-profile {\n  padding: 24px;\n  min-height: 100vh;\n}\n", ""]);
// Exports
module.exports = exports;
